export default __webpack_public_path__ + "static/Tek_Doorframe-75c26527d3a7434e25c9fe1e5ae93a3d.png";